export default __webpack_public_path__ + "static/media/freebee2.31a413a5.png";